<template>
	<section id="our-vision">
		<div class="container">
			<row v-if="currentLanguage === 'hu'">
				<column class="vision">
					<h2>Küldetésünk</h2>
					<p>Mérnöki, fejlesztési munkánkkal értéket, rendet, értékrendet viszünk a világba, ezáltal építjük a jövőt a mai és az elkövetkező generációk számára. A korszerű digitális technológiák lehetőségeivel élve élen járunk a fenntartható fejlődésben és a fejlesztésben. Tudásunk megosztásával segítjük partnereinket, szakmai környezetünket.</p>
				</column>
				<column class="spacer"></column>
				<column class="mission">
					<h2>Jövőképünk</h2>
					<p>A szakmai, technológiai, társadalmi, gazdasági, valamint környezeti változásokhoz alkalmazkodó és fejlődő közösségként, Magyarország építési-fejlesztési piacának meghatározó és kiváló mérnöki szereplőjeként növekvő nemzetközi partnerséget és jelenlétet valósítunk meg.</p>
				</column>
			</row>
			<row v-if="currentLanguage === 'en'">
				<column class="vision">
					<h2>Mission</h2>
					<p>With our engineering and development expertise, we bring Value, System and Value System into the world to build the future for today’s and the next generations. Taking advantage of most modern digital technologies, we are at the forefront of innovation and sustainable growth. By sharing our knowledge, we help our partners and our professional environment.</p>
				</column>
				<column class="spacer"></column>
				<column class="mission">
					<h2>Vision</h2>
					<p>As an innovative community that adapts to professional, technological, social, economic and environmental changes, and as a key and and excellent players in the Hungarian building and development industry, we grow our international presence and build partnerships.</p>
				</column>
			</row>
			<row v-if="currentLanguage === 'de'">
				<column class="vision">
					<h2>Mission</h2>
					<p>Mit unserem Ingenieurwesen und unserer Entwicklungsarbeit bringen wir Wert, Ordnung und Werteordnung in die Welt und errichten so die Zukunft der heutigen und zukünftigen Generationen. Die Möglichkeiten moderner digitaler Technologien nutzend, sind wir führend im Bereich nachhaltigen Fortschritts und Entwicklung. Indem wir unser Wissen teilen, helfen wir unseren Partnern sowie unserem fachlichen Umfeld.</p>
				</column>
				<column class="spacer"></column>
				<column class="mission">
					<h2>Vision</h2>
					<p>Als eine sich an fachliche, technologische, soziale, wirtschaftliche und ökologische Veränderungen anpassende und entwickelnde Gemeinschaft und als wichtiger und hervorragender Teilnehmer im Ingenieurwesen des ungarischen Bau- und Entwicklungsmarktes, verwirklichen wir eine wachsende internationale Partnerschaft und Präsenz.</p>
				</column>
			</row>
		</div>
	</section>
</template>

<script>

	import Column from './../../admin/Column.vue';
	import Row from './../../admin/Row.vue';

	export default {
		components: {
			Column,
			Row
		},
		computed: {
			currentLanguage() {
				return this.$route.params.lang || 'en';
			}
		}
	}
</script>

<style lang="scss" scoped>

	@import './../../../sass/variables';

	.spacer {
		@media screen and (max-width: $tablet-max) {
			display: none;
		}
	}

	#our-vision {
		position: relative;
		min-height: 600px;
		display: block;
		height: 70vh;
		z-index: 1;

		@media screen and (max-width: $tablet-max) {
			min-height: initial;
			height: initial;
		}

		&:after {
			transform: translate(0, -50%) rotate(20deg);
			transform-origin: 10% 70%;
			background-color: $blue;
			position: absolute;
			display: block;
			height: 100%;
			content: '';
			width: 100%;
			z-index: 1;
			left: 50%;
			top: 50%;

			@media screen and (max-width: $tablet-max) {
				display: none;
			}
		}

		.container {
			height: 100%;
		}

		.row {
			align-items: center;
			height: 100%;

			@media screen and (max-width: $tablet-max) {
				background-color: lighten(#000, 97%);
			}
		}
	}

	.vision {
		position: relative;
	    top: -10vh;
		padding-left: 15px;

		@media screen and (max-width: $tablet-max) {
			padding-bottom: 50px;
			padding-top: 50px;
			top: 0;
		}

		p {
			font-size: 20px;

			@media screen and (max-width: $mobile-max) {
				width: 95%;
			}
		}
	}

	.mission {
		padding-left: 15px;
		padding-right: 25px;
		background-color: $blue;
		position: relative;
		z-index: 2;
	    top: 10vh;

		@media screen and (max-width: $tablet-max) {
			padding-bottom: 50px;
			padding-top: 50px;
			top: 0;
		}

		h2,
		p {
			text-align: right;
			color: #fff;

			@media screen and (max-width: $tablet-max) {
				text-align: left;
			}
			@media screen and (max-width: $mobile-max) {
				padding-right: 15px;
			}
		}

		h2 {
			&:after {
				left: inherit;
				right: 0;

				@media screen and (max-width: $tablet-max) {
					right: initial;
					left: 0;
				}
			}
		}

		p {
			font-size: 20px;
		}
	}

</style>
